import { IconSvgProps } from '../types';

export const ContentShare = ({ size }: IconSvgProps) => (
  <svg
    id="icon-content-content share"
    width={size}
    height={size}
    viewBox="0 0 63 65"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="currentColor" fillRule="nonzero">
        <g>
          <path
            d="M8.82,30.79 C9.48,29.54 11,29.04 12.27,29.63 L12.39,29.68 L52.61,50.82 C53.9,51.5 54.39,53.1 53.72,54.39 C53.06,55.64 51.54,56.15 50.27,55.56 L50.15,55.5 L9.93,34.36 C8.64,33.68 8.14,32.09 8.82,30.79 Z"
            opacity="0.5"
          />
          <circle cx="51.38" cy="52.57" r="11.4497" />
          <path
            d="M50.19,9.7 C51.5,9.04 53.09,9.57 53.74,10.88 C54.37,12.14 53.89,13.68 52.67,14.36 L52.56,14.42 L12.63,34.39 C11.33,35.04 9.74,34.51 9.09,33.21 C8.45,31.94 8.93,30.41 10.15,29.72 L10.27,29.66 L50.19,9.7 Z"
            opacity="0.5"
          />
          <circle cx="11.45" cy="32.02" r="11.4497" />
          <circle cx="51.38" cy="11.47" r="11.4497" />
        </g>
      </g>
    </g>
  </svg>
);
